import React from "react";
import { Message } from "semantic-ui-react";
import { TriangleAlert, Info } from "lucide-react";

import styles from "./MessageSnack.module.scss";

export function MessageSnack({ message, messageType = "warning" }) {
  return (
    <div className={styles["empty-warning"]}>
      {messageType === "warning" && (
        <Message warning compact floating>
          <div className={styles["message-content"]}>
            <Info />
            <span>{message}</span>
          </div>
        </Message>
      )}
      {messageType === "error" && (
        <Message error compact floating>
          <div className={styles["message-content"]}>
            <TriangleAlert />
            <span>{message}</span>
          </div>
        </Message>
      )}
      {messageType === "info" && <Message info compact floating />}
      {messageType === "success" && <Message success compact floating />}
    </div>
  );
}
